import React from 'react';
import Layout from 'components/layout';
import Intro from 'components/intro';
import { graphql, Link } from 'gatsby';
import ArtDirectedFullBackground from 'components/ArtDirectedFullBackground'

const title = "Creature Texturing for Film/TV/Animation";
const description = "In this series, Justin Marshall shows you how to use Maya and Substance Painter to prepare a film-quality texture on a 3D model.";
const assetsURL = "https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodeling_film.zip";
const firstLessonPath = "01-model-import-and-project-setup";

import mayaLogo from 'assets/images/maya-logo.svg';
import spLogo from 'assets/images/substance-painter-logo.svg';

const prodLogos = [
    {url: mayaLogo, alt: 'Autodesk Maya'},
    {url: spLogo, alt: 'Substance Painter'}
];

const Index = ({ data }) => {
  return (
  <ArtDirectedFullBackground halfBG={false} desktopBG={data.desktop} mediumBG={data.medium} smallBG={data.small} className="intro-3ds-hero-img">
      <Layout title={title} pageDescription={description} imgURL={data.ogImage.childImageSharp.fixed.src}>

          <Intro title={title}
                 description={description}
                 assetsURL={assetsURL}
                 firstLessonPath={firstLessonPath}
                 prodLogos={prodLogos}>
          </Intro>

        <div className="image-credits">
            <a href="https://quantillion.wixsite.com/home" target="__blank" rel="noopener noreferrer">
                Image courtesy of Quantillion.
            </a>
        </div>
      </Layout>
    </ArtDirectedFullBackground>
)};


export default Index;

export const query = graphql`
  query course001HomeQuery {
    ogImage: file(relativePath: {eq: "images/og_intro_3dsMax.jpg"}) {
      childImageSharp {
        fixed {
          src
        }
      }
    }
    desktop: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    medium: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1400, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    small: file(relativePath: { eq: "images/bg-intro-3ds-max.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 490, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;


